import React from "react";

import { HStack, Icon, VStack, Text, Box } from "@chakra-ui/react";
import { VscQuote } from "react-icons/vsc";

const Quote = (props) => {
  const { quote, name, institution } = props;

  return (
    <Box paddingBottom="50px" width="100%">
      <HStack align="top">
        <Icon as={VscQuote} boxSize={10} color="#9a85f0" />
        <VStack>
            <Text>{quote}&#8221;</Text>
          <Box width="100%" textAlign="right" paddingRight="2px">
            <Text as="i">
              {name}, {institution}
            </Text>
          </Box>
        </VStack>
      </HStack>
    </Box>
  );
};

export default Quote;
